import { useApi } from '@repo-level/core-front';
import { referralProgram } from 'api/cms/referralProgram';
import type { PropsWithChildren } from 'react';
import { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { RefferalProgramApi } from '../../api/cms/referralProgram';

export interface ReferralProgramContextData {
  data: RefferalProgramApi | null;
  error: boolean;
  pending: boolean;
}

const initialState: ReferralProgramContextData = {
  data: null,
  error: false,
  pending: false,
};

export const ReferralProgramContext = createContext<ReferralProgramContextData>(
  null as any
);

export const ReferralProgramContextProvider = ({
  children,
}: PropsWithChildren<{}>) => {
  const {
    i18n: { language },
  } = useTranslation();

  const [requestReferralProgram, { error, pending, data }] =
    useApi(referralProgram);

  const [state, setState] = useState(initialState);

  useEffect(() => {
    requestReferralProgram(language);
  }, [language, requestReferralProgram]);

  useEffect(() => {
    if (error) {
      setState((prev) => ({ ...prev, data: null }));
    }

    if (data) {
      setState((prev) => ({ ...prev, data }));
    }
  }, [data, error]);

  return (
    <ReferralProgramContext.Provider value={{ ...state, error, pending }}>
      {children}
    </ReferralProgramContext.Provider>
  );
};
